import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-expand"
export default class extends Controller {
  connect() {
    // Auto-expand if this details element contains an active tab
    if (this.element instanceof HTMLDetailsElement) {
      const hasActiveTab = this.element.querySelector('.active-tab')
      if (hasActiveTab) {
        this.element.open = true
      }
    }
  }
} 